import Axios from 'axios';
import { HttpError, ValidationError, SessionInvalidError } from '../errors';

const http = Axios.create();

http.interceptors.request.use((request) => {
  // request.headers['X-EVENT-PASS-PHRASE'] =  process.env.VUE_APP_EVENT_PASS_PHRASE;
  return request;
});

http.interceptors.response.use((response) => {
  return response;
}, (error: any) => {

  if (!error.response) throw new HttpError(error, error.response);

  if (error.response.status === 400) {
    throw new ValidationError(error, error.response);
  } else {
    throw new HttpError(error, error.response);
  }

});

export default http;
